export interface IBankDeviseConverstionTauxDatatable {
  id: string;
  name: string;
  taux: string;
  effDate: string;
}

const columns = () => [
  {
    id: 'id',
    header: 'ID',
    accessorKey: 'id',
    cell: (ctx: any) => ctx.getValue(),
  },
  {
    id: 'name',
    header: 'Name',
    accessorKey: 'name',
    cell: (ctx: any) => ctx.getValue(),
  },
  {
    id: 'taux',
    header: 'Taux',
    accessorKey: 'taux',
    cell: (ctx: any) => ctx.getValue(),
  },
  {
    id: 'effDate',
    header: 'Eff.Date',
    accessorKey: 'effDate',
    cell: (ctx: any) => ctx.getValue(),
  },
];

export const BankDiviseConverstionTauxDatatableMeta = {
  columns,
};
